import { StyleSheet } from "react-native";
export default StyleSheet.create({
  container: {
    height: 44,
    justifyContent: "flex-end"
  },
  text: {
    color: "#006b95",
    fontWeight: "400",
    fontSize: 16,
    backgroundColor: "transparent",
    marginLeft: 10,
    marginRight: 10
  }
});